import { MenuPrincipalComponent } from './../menu-principal/menu-principal.component';
import { MainframeComponent } from './mainframe.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { MainFrameRoutingModule } from './mainframe-routing.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/app/', '.json');
}

@NgModule({
  declarations: [MainframeComponent, MenuPrincipalComponent],
  imports: [
    SharedModule,
    CommonModule,
    MainFrameRoutingModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainFrameModule { }
